import React from 'react';
const MiddleFeaturesContext = React.createContext({});

export default MiddleFeaturesContext;
